import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { Rank } from './Rank';

export type RankingsProps = {
    mobile: boolean;
    modal?: boolean;
    percentiles: any;
};

const CUTOFF = 80;

const acc = {
    name: 'ranking.accName',
    popoverHeader: 'ranking.accPopoverHeader',
    popoverText: 'ranking.accPopoverText',
};

const resp = {
    name: 'ranking.respName',
    popoverHeader: 'ranking.respPopoverHeader',
    popoverText: 'ranking.respPopoverText',
};

const pay = {
    name: 'ranking.payName',
    popoverHeader: 'ranking.payPopoverHeader',
    popoverText: 'ranking.payPopoverText',
};

const ship = {
    name: 'ranking.shipName',
    popoverHeader: 'ranking.shipPopoverHeader',
    popoverText: 'ranking.shipPopoverText',
};

export const Rankings = ({ mobile, modal, percentiles }: RankingsProps) => {
    const { accuracy, payment, responsiveness, shipping } = percentiles;
    const showPayment = payment >= CUTOFF;
    const showAccuracy = accuracy >= CUTOFF;
    const showShipping = shipping >= CUTOFF;
    const showResponsiveness = responsiveness >= CUTOFF;

    return (
        <div className={cn('flex grow justify-evenly', 'xsMax:justify-center xsMax:pr-sm')}>
            <div
                className={cn(
                    'my-md ml-xl flex w-full flex-wrap justify-start',
                    'smMax:items-center smMax:justify-evenly',
                    'xsMax:width-[unset] xsMax:mt-0',
                    {
                        'xsMax:justify-center': modal,
                        'ml-0 justify-evenly': mobile,
                    }
                )}
            >
                {showAccuracy && (
                    <Rank
                        isMobile={mobile}
                        name={acc.name}
                        popoverHeader={acc.popoverHeader}
                        popoverText={acc.popoverText}
                    />
                )}
                {showResponsiveness && (
                    <Rank
                        isMobile={mobile}
                        name={resp.name}
                        popoverHeader={resp.popoverHeader}
                        popoverText={resp.popoverText}
                    />
                )}
                {showPayment && (
                    <Rank
                        isMobile={mobile}
                        name={pay.name}
                        popoverHeader={pay.popoverHeader}
                        popoverText={pay.popoverText}
                    />
                )}
                {showShipping && (
                    <Rank
                        isMobile={mobile}
                        name={ship.name}
                        popoverHeader={ship.popoverHeader}
                        popoverText={ship.popoverText}
                    />
                )}
            </div>
        </div>
    );
};
